import  { ReactNode } from 'react';
import { useTheme, ThemeContext } from '@scramble/hooks';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const value = useTheme();
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
